/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgBulb24(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <g
        stroke='#00BB8E'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeMiterlimit={10}
        strokeWidth={1.5}
      >
        <path d='M1.5 12.5h2M4.722 4.722l1.414 1.414M12.5 1.5v2M20.278 4.722l-1.414 1.414M23.5 12.5h-2M18.5 12.5a6 6 0 10-12 0 5.996 5.996 0 004 5.651V22.5h4v-4.349c2.329-.824 4-3.04 4-5.651z' />
      </g>
      <defs>
        <clipPath id='bulb-24_svg__clip0'>
          <path fill='#fff' d='M0 0h24v24H0z' />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgBulb24;
